const handlerError = (error) => {
  let response = {message: "Operazione fallita: Server non raggiungibile.", status: false};


  if (error.response?.data?.message !== undefined) {
    response = { message: error.response.data.message, status: false}  
  } else if (error.response?.status !== undefined) {
    response = { message: handleErrorStatus(error.response.status)}
  } else if (error.response !== undefined) {
    response = {message: `${error.response.data.message}`, status: error.ok}
  } 
  return response
}



const handleErrorStatus = (status) => {
  let message = "Operazione fallita: Server non raggiungibile."
  
  switch(status) {
    case 401:
    case 403:
     message = "Non autorizzato"
      break;
    case 400:
     message = "Dati inseriti non corretti"
      break;
      }
      return message;
    }

export default handlerError;